<template>
  <div class="col-12 mb-primary">
    <div class="card card-with-shadow border-0 h-100">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <user-accordiant :data="documentUser"></user-accordiant>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAccordiant from "./UserAccordiant";
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  GET_ATTACH_DOCUMENT_USER,
  TASK_ATTACH_DOCUMENT,
} from "../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";

export default {
  components: { UserAccordiant },
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  name: "mytaskmodal",
  mixins: [ModalMixin, FormMixin],
  // props: {
  //   tableId: String,
  //   id: Number,
  // },
  data() {
    return {
      documentUser: {},
      inputs: {},
      tableId: "advance-table",
      rowData: {},
      dataToGet: {},
    };
  },

  methods: {
    submit() {
      this.inputs.task_id = this.$attrs["props"].id;
      axiosPost(TASK_ATTACH_DOCUMENT, this.inputs)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error.data.message);
        });
      // this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
      this.$hub.$emit("reload-" + tableid.tableId);
    },

    // getAttachDocumentUser() {
    //   let id = this.$attrs["props"];
    //   axiosGet(GET_ATTACH_DOCUMENT_USER + "/" + id.id)
    //     .then((res) => {
    //       // this.document = res.data;
    //       this.documentUser = res.data.attachdocumentuser;
    //       
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
  },
  mounted() {
    // this.getAttachDocumentUser();
    // 
    this.documentUser = this.$store.state.viewAttachDocument.dataToPass;
  },
};
</script>
